import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ActiveStatusComponent } from './active-status.component';
import { UserInfoComponent } from './user-info.component';
import { AvatarsGroupComponent } from './avatars-group.component';
import { TextTruncatePopoverComponent } from './text-truncate-popover.component';
import { SharedPipesModule } from '@shared/pipes/pipes.module';
import { SharedDirectivesModule } from '@shared/directives/shared-directives.module';
import { DeleteComponent } from './delete/delete.component';
import { DeactivateComponent } from './deactivate/deactivate.component';
import { ActivateComponent } from './activate/activate.component';
// import { defineLordIconElement } from 'lord-icon-element';
import lottie from 'lottie-web';
import { TabTitleComponent } from './tab-title/tab-title.component';
import { CoreCommonModule } from "../../@core/common.module";
import { ExtendedFormsModule } from '@libs/extended-forms/extended-forms.module';

@NgModule({
  declarations: [
    ActiveStatusComponent,
    UserInfoComponent,
    AvatarsGroupComponent,
    TextTruncatePopoverComponent,
    ActivateComponent,
    DeactivateComponent,
    DeleteComponent,
    TabTitleComponent,
  ],
  imports: [CommonModule, SharedPipesModule, SharedDirectivesModule, NgbModule, CoreCommonModule, ExtendedFormsModule],
  exports: [ActiveStatusComponent, UserInfoComponent, AvatarsGroupComponent, TextTruncatePopoverComponent, TabTitleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedComponentsModule {
  // constructor() {
  //   defineLordIconElement(lottie.loadAnimation);
  // }
}
